import {Component, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Location} from '@angular/common';
import {NgxSpinnerService} from 'ngx-spinner';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {OrganizationsService} from '../../../../core/services/organizations.service';
import {PlatformsService} from '../../../../core/services/platforms.service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {LearnCategoryService} from '../../../../core/services/learnCategory.service';
import {LearningPathsService} from '../../../../core/services/learningPaths.service';
import {TargetGroupService} from '../../../../core/services/targetGroup.service';
import moment from 'moment/moment';
import {MatDialog} from '@angular/material/dialog';
import {AddContentModalComponent} from '../addContentModal/add-content-modal.component';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import {EventService} from '../../../../core/services/event.service';
import {FuseConfigService} from '../../../../core/services/config.service';
import * as _ from 'lodash';
import {CheckModalComponent} from '../../check-save-modal/check-modal';
import {MatSnackBar} from '@angular/material/snack-bar';
import {FuseDeleteDialogComponent} from '../../../../core/components/delete-dialog/delete-dialog.component';
import {LevelService} from '../../../../core/services/level.service';
import {distinctUntilChanged} from 'rxjs/operators';
import {Subscription} from 'rxjs';
import {CompetencyService} from '../../../../core/services/competency.service';

@Component({
  selector: 'app-learning-path-detail',
  templateUrl: './learning-path-detail.component.html',
  styleUrls: ['./learning-path-detail.component.scss'],
  providers: [CompetencyService],
  standalone: false
})
export class LearningPathDetailComponent implements OnInit, OnDestroy {
  id: number;
  learningCategories: any[] = [];
  countries: any[] = [];
  cities: any[] = [];
  organizations: any[] = [];
  form: FormGroup =  new FormGroup({
    title: new FormControl('', [Validators.required]),
    description: new FormControl('', []),
    countryId: new FormControl({value: '', disabled: false}, [Validators.required]),
    cityId: new FormControl({value: '', disabled: false}, [Validators.required]),
    organizationId: new FormControl({value: '', disabled: false}, [Validators.required]),
    learningCategory: new FormControl('', []),
    targetGroup: new FormControl(''),
    picture: new FormControl('', []),
    visibility: new FormControl('public', []),
    startDate: new FormControl('', []),
    finishDate: new FormControl('', []),
    file: new FormControl(''),
    learningTargetGroup: new FormControl('', []),
    eventLevel: new FormControl('', []),
    skills: new FormControl('', [])
  });
  learningPath;
  picture;
  cropperOpened;
  array = [];
  selectAllTargetGroup = false;
  targetGroups = [];
  minFinishDate = new Date();
  minStartDate = new Date();
  content = [];
  returnBack;
  defaultForm;

  platformId;
  platforms;
  selectedPlatforms = [];
  showLevel = false;
  eventLevels = [];
  competencies = [];

  hasEvent = 0;
  hasElearning = 0;

  public subscription = new Subscription();

  constructor(private route: ActivatedRoute, private location: Location,
              private spinner: NgxSpinnerService,  private organizationService: OrganizationsService,
              private platformsService: PlatformsService, public learnCategoryService: LearnCategoryService,
              private translate: TranslateService, private learningPathService: LearningPathsService,
              private toastr: ToastrService, public targetGroupService: TargetGroupService,
              public eventService: EventService, private fuseConfig: FuseConfigService,
              public dialog: MatDialog, public snackBar: MatSnackBar, private router: Router,
              public eventLevel: LevelService, public competencyService: CompetencyService) {
    this.subscription.add(this.route.queryParams.subscribe((res: any) => {
      if (res && res.id) {
        this.id = +res.id;
      }
    }));
    this.subscription.add(this.fuseConfig.selectedPlatform.subscribe(res => {
      if (res && res.id) {
        this.platformId = res.id;
        // CHANGE FOR MORE PLATFORMS!
        this.showLevel = +this.platformId === 6;
        if (this.showLevel) {
          this.form.patchValue({eventLevel: null});
          this.checkEventLevel();
          this.checkCompetencies();
        }
      }
    }));
  }

  canDeactivate(): boolean {
    return this.goBack();
  }

  ngOnInit() {
    this.spinner.show();
    this.defaultForm = this.form.getRawValue();
    this.getLearnCategories();
    this.getLevel();
    this.init();
    this.subscription.add(this.fuseConfig.role.subscribe(res => {
      const selectControlCountry = this.form.get('countryId');
      const selectControlCity = this.form.get('cityId');
      const selectControlOrg = this.form.get('organizationId');
      if (res && res === 'organisationAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCity.disable({emitEvent: false});
        selectControlOrg.disable({emitEvent: false});
      }
      if (res && res === 'subCountryAdmin') {
        selectControlCountry.disable({emitEvent: false});
        selectControlCity.disable({emitEvent: false});
      }
      if (res && res === 'countryAdmin') {
        selectControlCountry.disable({emitEvent: false});
      }
    }));
  }

  init() {
    this.subscription.add(this.form.get('countryId').valueChanges.pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.organizationService.getCity(res).subscribe((result: any) => {
          this.cities = result;
          this.form.patchValue({cityId: null});
          if (this.learningPath) {
            this.form.patchValue({cityId: this.learningPath.cityId});
          }
          if (this.cities.length === 1 && !this.learningPath){
            this.form.patchValue({cityId: this.cities[0].id});
          }
        });
      }
    }));
    this.subscription.add(this.form.get('cityId').valueChanges.pipe(distinctUntilChanged()).subscribe((res) => {
      if (res) {
        this.organizationService.getOrganizationByCity(res).subscribe((result: any) => {
          this.organizations = result;
          this.form.patchValue({organizationId: null}, {emitEvent: false});
          if (this.learningPath && this.organizations.findIndex(el => el.id === this.learningPath.organizationId) !== -1) {
            this.form.patchValue({organizationId: this.learningPath.organizationId});
          }
          if (this.organizations.length === 1 && !this.learningPath){
            this.form.patchValue({organizationId: this.organizations[0].id});
          }
        });
      }
    }));
    this.subscription.add(this.form.get('organizationId').valueChanges.pipe(distinctUntilChanged()).subscribe((res) => {
      this.selectedPlatforms = [];
      if (res) {
        this.platformsService.getByOrganizationId(res).subscribe(platforms => {
          this.platforms = platforms;
          // CHANGE FOR MORE PLATFORMS!
          this.showLevel = (this.platforms.length === 1 && this.platforms[0].id === 6) || +this.platformId === 6;
          if (this.platforms.length === 1) {
            this.selectedPlatforms = [this.platforms[0].id];
          }
          this.checkPlatform();
        });
        this.getCompetenciesByOrganization(res);
      }
    }));
    this.subscription.add(this.organizationService.getCountry().subscribe((result: any) => {
      this.countries = result;
      if (this.learningPath) {
        this.form.patchValue({countryId: this.learningPath.countryId});
      }
      if (this.countries.length === 1 && !this.learningPath){
        this.form.patchValue({countryId: this.countries[0].id});
      }
    }));
    this.subscription.add(this.targetGroupService.targetGroupsGroped(false).subscribe((res: any) => {
      if (res && res.targetGroups) {
        this.targetGroups = res.targetGroups;
        this.checkTargetGroup();
      }
      this.spinner.hide();
    }));
    if (this.id) {
      this.getLearningPath();
    }
  }

  getCompetenciesByOrganization(id) {
    this.competencyService.competenciesByOrganization(id).subscribe((res: any) => {
      this.competencies = res;
      if (this.learningPath?.learningPathsSkills) {
        this.checkCompetencies();
      }
    });
  }

  checkCompetencies() {
    if (this.competencies && this.learningPath?.learningPathsSkills) {
      let array = this.learningPath?.learningPathsSkills.map(item => item.skillId);
      this.form.patchValue({skills: array});
      this.defaultForm = this.form.getRawValue();
    }
  }

  checkAllowedPlatforms() {
    // CHANGE FOR MORE PLATFORMS!
    let allowedPlatform = [6];
    if (!this.platformId) {
      this.showLevel =  this.selectedPlatforms.length > 0 && this.selectedPlatforms.every(el => allowedPlatform.includes(el));
    }
  }

  changePlatforms(platform) {
    this.selectedPlatforms = platform.value;
    this.checkAllowedPlatforms();
    if (this.showLevel) {
      this.form.patchValue({eventLevel: null});
    }
  }

  getLevel() {
    this.eventLevel.getLevels().then((result: any) => {
      this.eventLevels = result.map((res: any) => {
        return {label: res.status ? (res.level + ' / ' + res.status) : res.level  , value: res.id};
      });
      if (this.learningPath && this.learningPath.learningPathsEventLevels) {
        this.checkEventLevel();
      }
    });
  }

  getLearningPath() {
    this.spinner.show();
    this.learningPathService.getLearningPath(+this.id).subscribe((res: any) => {
      if (res) {
        this.learningPath = res;
        this.hasEvent = res?.learningPathsEvents?.length || 0;
        this.hasElearning = res?.learningPathsElearnings?.length || 0;
        if (this.learningPath.picture) {
          this.picture = this.learningPath.picture;
        }
        this.form.patchValue({
          title: res.title,
          description: res.description,
          countryId: res.countryId,
          cityId: res.cityId,
          organizationId: res.organizationId,
          learningCategory: res.learningCategory,
          picture: res.picture,
          startDate: res.startDate,
          finishDate: res.finishDate,
          visibility: res.visibility
        });
        if (res.startDate) {
          this.minFinishDate = moment(res.startDate, 'DD.MM.YYYY').toDate();
        }
        if (res.learningPathsEvents) {
          this.content = res.learningPathsEvents.map(item => {
            item.event.orderId = item.orderId;
            item.event.contentType = 'event';
            return item.event;
          }).sort((a, b) => a.orderId - b.orderId);
        }
        if (res.learningPathsElearnings) {
          this.content = this.content.concat(res.learningPathsElearnings.map(item => {
            item.elearning.orderId = item.orderId;
            item.elearning.contentType = 'elearning';
            return item.elearning;
          })).sort((a, b) => a.orderId - b.orderId);
        }
        this.checkCategory();
        this.checkTargetGroup();
        this.checkEventLevel();
        this.checkCompetencies();
        this.spinner.hide();
      }
    });
  }

  getLearnCategories() {
    this.learnCategoryService.getLearnCategories().subscribe((res: any) => {
      if (res) {
        this.learningCategories = res;
        this.checkCategory();
      }
    });
  }

  checkCategory() {
    if (this.learningCategories && this.learningPath?.learningPathsCategories) {
      let array = this.learningPath?.learningPathsCategories.map(item => item.learnCategoryId);
      this.form.patchValue({learningCategory: array});
      this.defaultForm = this.form.getRawValue();
    }
  }

  checkEventLevel() {
    if (this.eventLevels && this.learningPath?.learningPathsEventLevels) {
      let array = this.learningPath?.learningPathsEventLevels.map(item => item.eventLevelId);
      this.form.patchValue({eventLevel: array});
      this.defaultForm = this.form.getRawValue();
    }
  }

  checkPlatform() {
    if (this.platforms && this.learningPath?.learningPathsPlatforms) {
      this.selectedPlatforms = this.learningPath?.learningPathsPlatforms.map(item => item.platformId);
      this.checkAllowedPlatforms();
      this.getLevel();
    } else if (!this.learningPath && this.platformId) {
      this.selectedPlatforms.push(+this.platformId);
    }
  }

  checkTargetGroup() {
    if (this.learningPath?.learningPathsTargetGroups && this.targetGroups) {
      let array = this.learningPath?.learningPathsTargetGroups.map(item => item.targetGroupId);
      this.array = Array.from(array);
      this.form.patchValue({learningTargetGroup: array});
      this.defaultForm = this.form.getRawValue();
    }
  }

  getImg(e){
    this.form.patchValue({file: e});
  }

  openCropper(e) {
    this.cropperOpened = e;
    console.log(e);
  }

  back() {
    this.location.back();
  }

  updateParticipant(event) {

  }

  goBack() {
    let dialogRef;
    if (!this.returnBack && !_.isEqual(this.form.getRawValue(), this.defaultForm)) {
      dialogRef = this.dialog.open(CheckModalComponent, {
        panelClass: 'unsave-form-dialog'
      });

      return dialogRef.afterClosed().toPromise().then((result: any) => {
        if (result === 'leave') {
          return true;
        } else if (result === 'save') {
          if (this.form.valid) {
            this.addLeaningPath(false);
            return true;
          } else {
            let text = this.translate.instant('fill_req_field');
            this.snackBar.open(text, '', {duration: 2500});
            return false;
          }
        }
      });
    } else {
      return true;
    }
  }

  addLeaningPath(returnBack) {
    if (this.form.valid) {
      this.spinner.show();
      let data = this.form.getRawValue();
      if (this.id) {
        data.id = +this.id;
      }
      data.platforms = [];
      if (this.selectedPlatforms.length) {
        data.platforms = this.selectedPlatforms.join(',');
      }
      if (this.platformId) {
        data.platforms = this.platformId;
      }
      if (!this.showLevel) {
        data.eventLevel = [];
        data.skills = [];
      }
      data.learningPathEvents = JSON.stringify(this.content.map((item, index) => ({id: item.id, index: index, type: item.contentType}))
        .filter(item => item.type === 'event'));
      data.learningPathElearnings = JSON.stringify(this.content.map((item, index) => ({id: item.id, index: index, type: item.contentType}))
        .filter(item => item.type === 'elearning'));
      this.learningPathService.addLearningPath(data).subscribe((res: any) => {
        this.returnBack = returnBack;
        if (res) {
          this.toastr.success(this.translate.instant('successfully'), this.translate.instant('successfully'));
        }
        if (res && this.returnBack) {
          this.back();
        }
        this.spinner.hide();
      });
    }
  }

  deleteLP() {
    const dialogRef = this.dialog.open(FuseDeleteDialogComponent , { panelClass: 'unsave-form-dialog',
      width: '300px' ,
      data: {title: 'Delete' , message: 'deleteConfirm'}
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.spinner.show();
        this.learningPathService.deleteLearningPath(this.id).subscribe((res) => {
          this.toastr.success('Learning path deleted', 'Success!');
          this.router.navigate([ './pages/learningPaths' ]);
          this.spinner.hide();
        });
      }
    });
  }

  selectAll() {
    this.selectAllTargetGroup = !this.selectAllTargetGroup;
    for (let i = 0; i < this.targetGroups.length; i++) {
      let arr = [];
      let arrForPush = [];
      arr = JSON.parse(JSON.stringify(this.array));
      let count = 0;
      for (let j = 0; j < this.targetGroups[ i ].data.length; j++) {
        if (this.selectAllTargetGroup) {
          if (!arr.includes(this.targetGroups[ i ].data[ j ].id)) {
            arr.push(this.targetGroups[ i ].data[ j ].id);
          }
        } else {
          let index = arr.indexOf(this.targetGroups[ i ].data[ j ].id);
          if (index !== -1) {
            arr.splice(index , 1);
            count++;
            arrForPush.push(this.targetGroups[ i ].data[ j ].id);
          }
        }
      }
      this.array = Array.from(arr);
      if (this.selectAllTargetGroup) {
        this.targetGroups[i].selected = true;
      } else {
        this.targetGroups[i].selected = false;
      }
    }
    this.form.patchValue({learningTargetGroup: this.array});
  }
  setAll (name, indexTG) {
    this.selectAllTargetGroup = false;
    for (let i = 0; i < this.targetGroups.length; i++) {
      if (this.targetGroups[ i ].name === name) {
        let arr = [];
        let arrForPush = [];
        arr = this.array;
        let count = 0;
        for (let j = 0; j < this.targetGroups[ i ].data.length; j++) {
          let index = this.array.indexOf(this.targetGroups[ i ].data[ j ].id);
          if (index !== -1) {
            arr.splice(index , 1);
            count++;
            arrForPush.push(this.targetGroups[ i ].data[ j ].id);
          } else {
            arr.push(this.targetGroups[ i ].data[ j ].id);
          }
        }
        if (count === this.targetGroups[ i ].data.length) {
          this.array = Array.from(arr);
        } else {
          arrForPush.forEach((item) => {
            arr.push(item);
          });
          this.array = Array.from(arr);
        }
      }
    }
    if (this.targetGroups[ indexTG ].data && this.targetGroups[ indexTG ].data[ 0 ] && this.array.includes(this.targetGroups[ indexTG ].data[ 0 ].id)) {
      this.targetGroups[ indexTG ].selected = true;
    } else {
      this.targetGroups[ indexTG ].selected = false;
    }
    this.form.patchValue({learningTargetGroup: this.array});
  }

  changeTG(){
    this.selectAllTargetGroup = false;
    this.form.patchValue({learningTargetGroup: this.array});
  }

  closePicker(event, data) {
    let res = data.datepickerInput.value;
    if (res) {
      if (event === 'startDate') {
        this.form.patchValue({startDate: moment(res).format('DD.MM.YYYY')});
        this.minFinishDate = res;
      }
      if (event === 'finishDate') {
        this.form.patchValue({finishDate: moment(res).format('DD.MM.YYYY')});
      }
    }
  }

  cleanStartDate() {
    this.form.patchValue({startDate: ''});
    this.minFinishDate = new Date();
  }

  cleanFinishDate() {
    this.form.patchValue({finishDate: ''});
  }

  addEvent() {
    const dialogRef = this.dialog.open(AddContentModalComponent ,
      { panelClass: 'contact-form-dialog',
        width: '800px', minHeight: '500px', disableClose: true,
        data: {
          type: 'event',
          organizationId: this.form.get('organizationId').value,
          chosenIds: this.content.filter(item => item.contentType === 'event').map(item => item.id)
        }
      });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      if (result?.length) {
        this.content = this.content.filter(item => (item.contentType === 'elearning' || result.findIndex(el => el.id === item.id) !== -1));
        for (let i = 0; i < result.length; i++) {
          result[ i ].contentType = 'event';
          if (this.content.findIndex(el => el.id === result[ i ].id && el.contentType === 'event') === -1) {
            this.content.push(result[ i ]);
          }
        }
      } else {
        this.content = this.content.filter(item => item.contentType !== 'event');
      }
    });
  }

  addElearning() {
    const dialogRef = this.dialog.open(AddContentModalComponent ,
      { panelClass: 'contact-form-dialog',
        width: '800px', minHeight: '500px', disableClose: true,
        data: {
          type: 'elearning',
          organizationId: this.form.get('organizationId').value,
          chosenIds: this.content.filter(item => item.contentType === 'elearning').map(item => item.id)
        }
      });
    dialogRef.afterClosed().subscribe(result => {
      if (!result) {
        return;
      }
      if (result?.length) {
        this.content = this.content.filter(item => (item.contentType === 'event' || result.findIndex(el => el.id === item.id) !== -1));
        for (let i = 0; i < result.length; i++) {
          result[ i ].contentType = 'elearning';
          if (this.content.findIndex(el => el.id === result[ i ].id && el.contentType === 'elearning') === -1) {
            this.content.push(result[ i ]);
          }
        }
      } else {
        this.content = this.content.filter(item => item.contentType !== 'elearning');
      }
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.content, event.previousIndex, event.currentIndex);
  }

  getImage(name) {
    return this.eventService.getFileStream(name);
  }

  removeFromContent(item) {
    let index = this.content.findIndex(el => el.id === item.id && el.contentType === item.contentType);
    if (index !== -1) {
      this.content.splice(index, 1);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
